import React from "react";
import PropTypes from "prop-types";
import { icon, IconComponent } from "../../../../../../common/components";
import { translate } from "../../../../../../common/providers";
import styles from "./CommitmentDefinitionHeaders.module.css";

const HEADERS = [
	{ name: "common:field.name", sortKey: "name" },
	{ name: "dsi.commitment-definition.header.theme", sortKey: "themeName" },
	{ name: "dsi.commitment-definition.header.agent" },
	{ name: "dsi.commitment-definition.header.state" },
];

export default function CommitmentDefinitionHeaders({ sortDirection, sortKey, onClickSort }) {
	return (
		<div className={styles.main}>
			{HEADERS.map((header) => {
				const isSorting = sortKey === header.sortKey;
				if (header.sortKey) {
					return (
						<div
							key={header.name}
							className={styles.sortLabel}
							role="presentation"
							onClick={() => onClickSort(header.sortKey)}
						>
							{translate(header.name)}
							{!isSorting && (
								<IconComponent
									className={`${styles.icon} ${styles["icon--inactive"]}`}
									icon={icon.faSort}
								/>
							)}
							{isSorting && sortDirection === "asc" && (
								<IconComponent className={styles.icon} icon={icon.faSortUp} />
							)}
							{isSorting && sortDirection === "desc" && (
								<IconComponent className={styles.icon} icon={icon.faSortDown} />
							)}
						</div>
					);
				}
				return <div key={header.name}>{translate(header.name)}</div>;
			})}
			<div />
		</div>
	);
}

CommitmentDefinitionHeaders.propTypes = {
	sortDirection: PropTypes.string,
	sortKey: PropTypes.string,
	onClickSort: PropTypes.func.isRequired,
};

CommitmentDefinitionHeaders.defaultProps = {
	sortDirection: "asc",
	sortKey: "",
};
